module.exports = __webpack_public_path__ + "static/media/02.55c5621a.jpg";